import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import history from "./history";


// Turnero
import TurnTypeABM from "./components/sistema/Turnero/Admin/TurnTypeABM";
import UserABM from "./components/sistema/Turnero/Admin/UserABM";
import ScreenParams from "./components/sistema/Turnero/Admin/ScreenParams";
import TurneroAdminPanel from "./components/sistema/Turnero/Admin/TurneroAdminPanel";
import QueueDisplay from "./components/sistema/Turnero/ClientView/QueueDisplay";
import TurnTotem from "./components/sistema/Turnero/ClientView/TurnTotem";
import StaffLogin from "./components/sistema/Turnero/StaffView/StaffLogin";
import StaffConsole from "./components/sistema/Turnero/StaffView/StaffConsole";
import StaffAdmin from "./components/sistema/Turnero/StaffView/StaffAdmin";
import TurneroAuth from "./components/sistema/Turnero/Login/TurneroAuth";
import SuperAdminPanel from "./components/sistema/Turnero/SuperAdmin/SuperAdminPanel";
import VerifyEmail from "./components/sistema/Turnero/Login/VerifyEmail";
import WebBookingWizard from "./components/sistema/Turnero/ClientView/WebBookingWizard";
import AppointmentValidation from "./components/sistema/Turnero/ClientView/AppointmentValidation";
import { useParams } from "react-router-dom";

import SuperAdminStats from './components/sistema/Turnero/SuperAdmin/SuperAdminStats';
import SuperAdminUsers from './components/sistema/Turnero/SuperAdmin/SuperAdminUsers';
import SuperAdminEmpresas from './components/sistema/Turnero/SuperAdmin/SuperAdminEmpresas';
import SuperAdminSucursales from './components/sistema/Turnero/SuperAdmin/SuperAdminSucursales';
import SuperAdminStaff from './components/sistema/Turnero/SuperAdmin/SuperAdminStaff';
import MenuBuilderPanel from './components/sistema/Turnero/SuperAdmin/MenuBuilder/MenuBuilderPanel';
import QueryBuilderPanel from './components/sistema/Turnero/SuperAdmin/MenuBuilder/QueryBuilderPanel';
import ConnectionManager from './components/sistema/Turnero/SuperAdmin/MenuBuilder/ConnectionManager';
import ApiPortalPanel from './components/sistema/Turnero/SuperAdmin/ApiPortal/ApiPortalPanel';

import DynamicModuleResolver from './components/sistema/Turnero/SuperAdmin/DynamicModuleResolver';

// Wrapper for Wizard to extract sucursalId
const BookingWrapper = ({ ipserv }) => {
  const { sucursalId } = useParams();
  return <WebBookingWizard ipserv={ipserv} sucursalId={sucursalId} />;
};


function App() {
  const ipserv = process.env.REACT_APP_API_URL || '';
  //flag turnero
  sessionStorage.setItem('flag', 'true')

  return (
    <div id="root">
      <Router basename="/tufilaapp">
        <Routes>
          <Route path="/Turnero/Login" element={<TurneroAuth ipserv={ipserv} />} />
          <Route path="/verify-email" element={<VerifyEmail ipserv={ipserv} />} />
          <Route path="/reset-password" element={<TurneroAuth ipserv={ipserv} />} />

          {/* Super Admin route — Uses nested routing for the new Sidebar/Panel system */}
          <Route path="/Turnero/SuperAdmin" element={
            (() => {
              try {
                const p = JSON.parse(localStorage.getItem('tufila_admin') || '{}');
                return p.AdminRole === 'SUPERADMIN'
                  ? <SuperAdminPanel ipserv={ipserv} />
                  : <TurneroAuth ipserv={ipserv} />;
              } catch { return <TurneroAuth ipserv={ipserv} />; }
            })()
          }>
            {/* The index route for the panel (Dashboard) */}
            <Route index element={<SuperAdminStats ipserv={ipserv} />} />

            {/* Static Modules (Defined here ONCE) */}
            <Route path="admins" element={<SuperAdminUsers ipserv={ipserv} />} />
            <Route path="companies" element={<SuperAdminEmpresas ipserv={ipserv} />} />
            <Route path="branches" element={<SuperAdminSucursales ipserv={ipserv} />} />
            <Route path="staff" element={<SuperAdminStaff ipserv={ipserv} />} />
            <Route path="menubuilder" element={<MenuBuilderPanel ipserv={ipserv} />} />
            <Route path="querybuilder" element={<QueryBuilderPanel ipserv={ipserv} />} />
            <Route path="connections" element={<ConnectionManager ipserv={ipserv} />} />
            <Route path="apiportal" element={<ApiPortalPanel ipserv={ipserv} />} />

            {/* Catch-all for Dynamic Modules (The resolver handles the search) */}
            <Route path="*" element={<DynamicModuleResolver ipserv={ipserv} />} />
          </Route>

          {/* Company Admin route */}
          <Route path="/Turnero/Admin" element={
            localStorage.getItem('tufila_admin')
              ? <TurneroAdminPanel ipserv={ipserv} />
              : <TurneroAuth ipserv={ipserv} />
          } />

          <Route path="/Turnero/Admin/PanelTest" element={<TurneroAdminPanel ipserv={ipserv} />} />
          <Route path="/Turnero/Admin/Tipos" element={<TurnTypeABM ipserv={ipserv} />} />
          <Route path="/Turnero/Admin/Usuarios" element={<UserABM ipserv={ipserv} />} />
          <Route path="/Turnero/Admin/Parametros" element={<ScreenParams ipserv={ipserv} />} />
          <Route path="/TurneroView/:type" element={<QueueDisplay ipserv={ipserv} />} />
          <Route path="/TurneroTotem" element={<TurnTotem ipserv={ipserv} />} />
          <Route path="/TurneroStaff" element={<StaffAdmin ipserv={ipserv} />} />
          <Route path="/booking/:sucursalId" element={<BookingWrapper ipserv={ipserv} />} />
          <Route path="/validate-appointment" element={<AppointmentValidation ipserv={ipserv} />} />
          <Route path="/" element={<TurneroAuth ipserv={ipserv} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;

